/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";
import ExploreRoomInitState from "../../../rooms/ExploreRoom/state"
import { EXPLORE_ROOM } from "../../../rooms/RoomNameConstants";

const initialState = { ...ExploreRoomInitState };

const exploreRoomSlice = createSlice({
    name: EXPLORE_ROOM,
    initialState: initialState,
    reducers: {
        setCenterGraphCompare: (state, action) => {
            state.centerGraphCompare.data = action.payload
        },
        setRotationGraphCompare: (state, action) => {
            const callback = action.payload
            Object.assign(
                state.centerGraphCompare.position.rotation,
                callback(state.centerGraphCompare.position.rotation)
            )
        },
        setZoomGraphCompare: (state, action) => {
            const callback = action.payload
            state.centerGraphCompare.position.scale = callback(state.centerGraphCompare.position.scale)
        },
        setNewGeneration: (state, action) => {
            state.centerGraphCompare.isRequested = action.payload
        },
        setWorkstation: (state, action) => {
            state.centerGraphCompare.workstation = action.payload
        },
        setTimeRage: (state, action) => {
            state.centerGraphCompare.timeRange = action.payload
        },
        loadRemoteExploreRoom: (state, action) => {
            Object.assign(state, action.payload)
        }
    }
});

export const {
    setRotationGraphCompare,
    setCenterGraphCompare,
    loadRemoteExploreRoom,
    setZoomGraphCompare,
    setNewGeneration,
    setWorkstation,
    setTimeRage,
} = exploreRoomSlice.actions;

export default exploreRoomSlice;
